import { Component, Input } from "@angular/core";

@Component({
  selector: "app-status-box",
  templateUrl: "./status-box.component.html",
  styleUrls: ["./status-box.component.scss"],
})
export class StatusBoxComponent {
  @Input() url: string;
  @Input() queryParams: any = {};
  @Input() tooltip: any;
  @Input() data: any


  constructor() {}
}
